import { animate, state, style, transition, trigger } from '@angular/animations';

export const expandRotate = trigger('expandRotateAnimation', [
    state('expanded', style({ transform: 'rotate(180deg)' })),
    transition('collapsed => expanded', animate('300ms ease-in')),
    transition('expanded => collapsed', animate('300ms ease-out')),
]);
